import { render } from "./CartoonFigure.vue?vue&type=template&id=88622df8&scoped=true"
import script from "./CartoonFigure.vue?vue&type=script&lang=js"
export * from "./CartoonFigure.vue?vue&type=script&lang=js"

import "./CartoonFigure.vue?vue&type=style&index=0&id=88622df8&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88622df8"]])

export default __exports__